import { removePanZoom } from '@/lib/annotations/image-coord-conversion'
import { screenToUv } from '@/lib/annotations/site-slide-conversion'

export class ArgumentsError extends Error {}

export function makeHistoryObserver(history: HistoryEvent[]): DrawingObserver {
  return {
    setup(opts) {
      if ('strokeStyle' in opts && !opts.strokeStyle) {
        throw new ArgumentsError('Cannot set stroke to null or undefined')
      }
      if ('lineWidth' in opts && !opts.lineWidth) {
        throw new ArgumentsError('Cannot set line width to null or undefined')
      }
      const lastEvent = history[history.length - 1]
      if (lastEvent?.points.length === 0) {
        Object.assign(lastEvent, opts)
      } else {
        history.push(Object.assign({ points: [] }, opts))
      }
    },

    start(coord, transform = { x: 0, y: 0, zoom: 1 }) {
      const lastEvent = history[history.length - 1]
      // normalize the coordinates for record-keeping
      const normalized = _normalize(coord, transform)

      if (lastEvent?.points.length === 0) {
        lastEvent.points.push(normalized)
      } else {
        history.push({ ...lastEvent, points: [normalized] })
      }
    },

    move(coord, transform = { x: 0, y: 0, zoom: 1 }) {
      const lastEvent = history[history.length - 1]
      // normalize the coordinates for record-keeping
      const normalized = _normalize(coord, transform)
      lastEvent.points.push(normalized)
    },

    reset() {
      const lastEvent = history[history.length - 1]
      history.splice(0)
      history.push({ ...lastEvent, points: [] })
    },

    undo() {
      let lastEvent = history[history.length - 1]
      const setupEvent = { ...lastEvent, points: [] }
      if (lastEvent.points.length === 0) {
        history.pop()
      }

      history.pop()

      lastEvent = history[history.length - 1]
      if (!lastEvent || setupEvent.strokeStyle !== lastEvent.strokeStyle || setupEvent.lineWidth !== lastEvent.lineWidth) {
        history.push(setupEvent)
      }
    },
  }
}

function _normalize(coord: Point, transform: Point & { zoom: number; uv?: Point }) {
  let normalized = removePanZoom(coord, { x: transform.x, y: transform.y }, transform.zoom)
  if (transform.uv) normalized = screenToUv(normalized, transform.uv)
  return normalized
}
